<lex-sidenav-container>
  <ng-container left>
    <div></div>
    <lex-account-search [(selectedAccount)]="selectedAccount" (selectedAccountChange)="selectAccount()" [selectedAccountId]="selectedAccountId" [source]="'manage-case'"></lex-account-search>
    <div></div>
  </ng-container>

  <!--Manage Case Main Layout main content-->
  <ng-container right>
    <div style="flex-direction: column; box-sizing: border-box; display: flex; place-content: stretch space-between; align-items: stretch; flex: 1 1 0%; gap: 20px;" *ngIf="!selectedCase">
      <div></div>
      <div style="flex-direction: row; box-sizing: border-box; display: flex; flex: 1 1 0%; gap: 20px;">
        <div></div>
        <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; flex-direction: column" *ngIf="cases$ | async as cases">
          <mat-toolbar color="primary" class="toolbar-over-card">
            <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-start; align-items: center;">
              <mat-card-title>Total Cases: {{cases.length}}</mat-card-title>
            </div>
            <div style="box-sizing: border-box; display: flex; flex: 1 1 0%; place-content: center flex-end; align-items: center; margin-bottom: 8px;">
              <button mat-icon-button matTooltip="Create New Case In Account" id="addNewCaseInAccount" *ngIf="selectedAccount" (click)="addCase()"><mat-icon>add</mat-icon></button>
            </div>
          </mat-toolbar>
          <div style="flex: 1 1 0%; box-sizing: border-box;">
            <mat-card appearance="outlined">
              <div style="font-size: 15px" *ngIf="!selectedAccount">
                No Account Selected
              </div>
              <div style="font-size: 15px" *ngIf="selectedAccount && cases.length === 0">
                No cases in Account
              </div>
              <mat-card-content *ngIf="selectedAccount && cases.length > 0">
                <table matSort (matSortChange)="sortData($event)" width="100%">
                  <tr style="color: #1a237e;">
                    <th mat-sort-header="caseName" width="40%"> Case Name </th>
                    <th mat-sort-header="simpleCaseId" width="10%"> Case Id </th>
                    <th mat-sort-header="dateTimeCreated" width="25%"> Date Created </th>
                    <th mat-sort-header="userCount" width="20%"> Number of Users </th>
                    <th width="5%"></th>
                  </tr>

                  <tr class="mat-row" *ngFor="let case of cases" [attr.id]="'manageCases.'+case.caseId" (mouseover)="hoverFieldId=case.caseId" (mouseout)="hoverFieldId=null" (click)="selectedCase = case">
                    <td>{{case.caseName}}</td>
                    <td>{{case.simpleCaseId}}</td>
                    <td>{{case.dateTimeCreated | date: 'MM/dd/yyyy h:mm a'}}</td>
                    <td>
                      <span matTooltipClass="tooltip-list" [matTooltipPosition]="'right'" style="padding-left: 7px" [matTooltip]="getCaseUserList(case) | tooltipList">{{case.accessibleUsers.length}}</span>
                    </td>
                    <td><button mat-icon-button [attr.id]="'deleteCase.'+case.caseId" matTooltip="Delete Case" [style.visibility]="case.caseId !== hoverFieldId ? 'hidden': 'visible'" (click)="removeCase($event, case.caseId)" style="pointer-events: auto;"><mat-icon>close</mat-icon></button></td>
                  </tr>
                </table>
              </mat-card-content>
            </mat-card>
          </div>
        </div>
        <div></div>
      </div>
      <div></div>
    </div>
    <lex-manage-case-edit *ngIf="selectedCase" style="flex: 1 1 0%; box-sizing: border-box;" [accountId]="selectedAccount.accountId" [case]="selectedCase" [currentUsers]="selectedCase.accessibleUsers" (clearSelectionChange)="clearSelectedCase($event)"></lex-manage-case-edit>
  </ng-container>
</lex-sidenav-container>
